import React, { memo } from 'react';

import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState.ts';
import { isErrorMarkedAsHandled } from '@confluence/graphql-error-processor/entry-points/GraphqlErrorProcessor.ts';
import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';
import { GLOBAL_PAGE_FORGE } from '@confluence/named-routes/entry-points/routes.ts';

import { FORGE_MODULE_GLOBAL_PAGE } from '../../ForgeModuleType.ts';
import { LazyForgeUIExtensions } from '../../lazy.ts';
import { getAppId } from '../../utils/appData.ts';

import { ForgeKeyboardShortcut } from './ForgeKeyboardShortcut.tsx';

export const ForgeGlobalKeyboardShortcuts: React.MemoExoticComponent<() => React.JSX.Element> =
	memo((): React.JSX.Element => {
		const { push } = useRouteActions();

		return (
			<LazyForgeUIExtensions
				moduleType={FORGE_MODULE_GLOBAL_PAGE}
				render={(forgeModules, loading, error) => {
					if (loading) return null;

					if (error) {
						if (!isErrorMarkedAsHandled(error)) {
							return <ErrorDisplay error={error} />;
						}
						return null;
					}

					return forgeModules.map((module) => (
						<ForgeKeyboardShortcut
							key={module.id}
							module={module}
							action={() =>
								push(
									GLOBAL_PAGE_FORGE.toUrl({
										appId: getAppId(module),
										envId: module.environmentId,
										forgeManifestRoute: module.properties.route,
									}),
								)
							}
						/>
					));
				}}
			/>
		);
	});
